import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorDetail } from '@core/domain/http.dto';

export function extractBackendMessage(error: unknown): string {
  if (!(error instanceof HttpErrorResponse)) return 'An error occurred';
  if (error.error instanceof ErrorEvent) {
    return error.error.message || 'An error occurred';
  }

  const details: ApiErrorDetail[] | undefined = error.error?.error?.details;

  const firstDetailMessage = Array.isArray(details) ? details.find(d => !!d?.message)?.message : undefined;
  if (firstDetailMessage) return firstDetailMessage;
  return error.message || `status code ${error.status}`;
}

export function extractBackendMessageForAttribute(error: unknown, attribute: string): string | null {
  if (!(error instanceof HttpErrorResponse)) return null;

  const details: ApiErrorDetail[] | undefined = error.error?.error?.details;
  if (!Array.isArray(details)) return null;

  const target = details.find(d => (d?.attribute ?? '').toLowerCase() === attribute.toLowerCase());
  return typeof target?.message === 'string' ? target.message : null;
}
